<template>
  <div>
    <div class="atm-rounded shadow-none  w-100 ">
      <b-skeleton animation="fade" height="40px" width="100%"></b-skeleton>
    </div>
    <b-row class="wrapper-projects py-4">
      <b-col v-for="project in projectsTasks" :key="project" sm="12" md="4">
        <b-skeleton animation="fade" height="40vw" width="100%"></b-skeleton>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      projectsTasks: [1, 2, 3],
    };
  },
};
</script>

